module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"hero_title":"Always within reach.","title":"Contact"},"nl":{"hero_title":"Altijd binnen handbereik.","title":"Contact"}}')
  delete Component.options._Ctor
}
